import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">株式会社Life Industry</h3>
            <p className="text-gray-400 leading-relaxed mb-6">
              内装工事・改修工事のプロフェッショナルとして、お客様の理想の空間づくりをサポートします。
            </p>
            <div className="flex gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white rounded-full flex items-center justify-center hover:bg-white hover:text-black transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white rounded-full flex items-center justify-center hover:bg-white hover:text-black transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-fill"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white rounded-full flex items-center justify-center hover:bg-white hover:text-black transition-colors cursor-pointer"
              >
                <i className="ri-instagram-fill"></i>
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">会社情報</h4>
            <div className="space-y-4 text-gray-400">
              <div>
                <p className="text-sm font-bold text-white mb-1">住所</p>
                <p className="text-sm">〒818-0137<br />福岡県太宰府市</p>
              </div>
              <div>
                <p className="text-sm font-bold text-white mb-1">電話番号</p>
                <p className="text-sm">092-928-3267</p>
              </div>
              <div>
                <p className="text-sm font-bold text-white mb-1">メールアドレス</p>
                <p className="text-sm">info@h.life-industry.jp</p>
              </div>
            </div>
          </div>

          {/* Site Map */}
          <div>
            <h4 className="text-lg font-bold mb-4">サイトマップ</h4>
            <nav className="space-y-3">
              <Link
                to="/"
                className="block text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                トップ
              </Link>
              <Link
                to="/company"
                className="block text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                会社概要
              </Link>
              <Link
                to="/services"
                className="block text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                事業内容
              </Link>
              <Link
                to="/contact"
                className="block text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                お問い合わせ
              </Link>
            </nav>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            &copy; 2026 株式会社Life Industry. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
